"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MOBILE_SCREEN_WIDTH = 721;
var REGEX = /reverb.*ios|android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
exports.default = {
    userAgent: function () {
        return navigator.userAgent;
    },
    isMobileBrowser: function () {
        return REGEX.test(this.userAgent());
    },
    getClickEvent: function () {
        return this.isMobileBrowser() ? 'touchend' : 'click';
    },
    isMobileScreenWidth: function () {
        return window.screen.width < MOBILE_SCREEN_WIDTH;
    },
};
//# sourceMappingURL=mobile_detection.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/reverb-js-common/mobile_detection.js
// module id = cnVy
// module chunks = 20 21